import axios from 'axios';
import environment from '@src/environment';
import optimizeCloudinaryUrl from '@src/utils/cloudinary-optimizations';

export const state = {
  favorites: [],
};

export const getters = {
  favoriteDishesMap: (state) => {
    const map = { r: {}, m: {} };
    if (state.favorites) {
      state.favorites.forEach((element) => {
        map[element.type][element.id] = true;
      });
    }
    return map;
  },
};

export const mutations = {
  optimisticPushIntoFavorites(state, value) {
    state.favorites.push(value);
  },
  setFavorites(state, value) {
    state.favorites = value;
  },
  spliceOutFavorite(state, { dishType, dishId }) {
    const index = _.findIndex(state.favorites, (favorite) => {
      return favorite.type === dishType && favorite.id === dishId;
    });
    state.favorites.splice(index, 1);
  },
};

export const actions = {
  async getFavorites(ctx, {} = {}) {
    return await axios
      .get(`${environment.FAVORITE_DISHES_URL}`)
      .then((res) => {
        res.data.map((recipe) => {
          recipe.imageurl = optimizeCloudinaryUrl(recipe.imageurl);
          return recipe;
        });

        return ctx.commit('setFavorites', res.data);
      })
      .catch((err) => console.log(err));
  },
  async addFavorite(ctx, { dishType, dishId }) {
    const payload = { mealsToPin: [], recipesToPin: [] };
    if (dishType === 'm') {
      payload.mealsToPin.push(dishId);
    } else {
      payload.recipesToPin.push(dishId);
    }

    ctx.commit('optimisticPushIntoFavorites', { type: dishType, id: dishId });

    return await axios
      .post(`${environment.ADD_FAVORITE_DISH_URL}`, payload)
      .then((res) => ctx.commit('setFavorites', res.data))
      .catch((err) => console.log(err));
  },
  async removeFavorite(ctx, { dishType, dishId }) {
    const payload = { mealsToUnPin: [], recipesToUnPin: [] };
    if (dishType === 'm') {
      payload.mealsToUnPin.push(dishId);
    } else {
      payload.recipesToUnPin.push(dishId);
    }

    ctx.commit('spliceOutFavorite', { dishType, dishId });

    return await axios
      .post(`${environment.REMOVE_FAVORITE_DISH_URL}`, payload)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};
